import React from 'react'

import { ActiveRoomProvider } from './ActiveRoom'

/**
 */
export const DataInitializer = ({ children }) => (
  <ActiveRoomProvider>{children}</ActiveRoomProvider>
)
